import getConfig from 'next/config';
import { clearAllCookies, setCookie, setTokenInCookies } from '../../../hooks/useCookie';
import { clearLocalStorage } from '../../../hooks/useLocalStorage';
import { extendSessionApi } from '../../../integration/session.api';

const { publicRuntimeConfig } = getConfig();

export const logout = setShowSessionWarning => {
  clearLocalStorage();
  clearAllCookies();

  window.location.href = `${publicRuntimeConfig.NEXT_PUBLIC_OPENCMS}/shop/broadband`;
  setShowSessionWarning(false);
};

export const extendSession = async ({ graphql, setShowSessionWarning }) => {
  try {
    const data = await extendSessionApi(graphql);

    if (data) {
      // const refreshTokenExpiresIn = data.refreshToken.refresh_expires_in * 1000;
      // const now = new Date().getTime();
      // const sessionExpiryTime = new Date(now + refreshTokenExpiresIn).getTime();
      // const session = {
      //   sessionExpiryTime,
      //   refreshTokenExpiresIn,
      // };

      // setCookie('ION', 'session', JSON.stringify(session));
      // setCookie('ION', 'access_Token', data.refreshToken.access_token);
      // setCookie('ION', 'refresh_Token', data.refreshToken.refresh_token);

      setCookie(
        'ION',
        'refresh_Token',
        data?.refreshToken?.refresh_token,
        new Date().getTime() + 60 * 60 * 1000
      );
      await setTokenInCookies(
        data?.refreshToken?.access_token,
        new Date().getTime() + 60 * 60 * 1000
      );
      const refreshTokenExpiresIn = data.refreshToken.refresh_expires_in * 1000;
      const sessionExpiryTime = new Date(new Date().getTime() + refreshTokenExpiresIn).getTime();
      setCookie(
        'ION',
        'session',
        JSON.stringify({
          sessionExpiryTime,
          refreshTokenExpiresIn,
        })
      );
      setShowSessionWarning(false);
    }
  } catch (error) {
    console.error(error);
    logout(setShowSessionWarning);
  }
};
